export var NewSegmentUITelemetryEventNames;
(function (NewSegmentUITelemetryEventNames) {
    NewSegmentUITelemetryEventNames["CreateOrEditColumnStart"] = "CreateOrEditColumnStart";
    NewSegmentUITelemetryEventNames["SaveColumn"] = "SaveColumn";
    NewSegmentUITelemetryEventNames["SaveColumnValid"] = "SaveColumnValid";
    NewSegmentUITelemetryEventNames["SaveColumnSuccess"] = "SaveColumnSuccess";
    NewSegmentUITelemetryEventNames["CancelColumnOp"] = "CancelColumnOp";
})(NewSegmentUITelemetryEventNames || (NewSegmentUITelemetryEventNames = {}));

//# sourceMappingURL=NewSegmentUITelemetryEventNames.js.map
